import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const Seo = (props) => {
  const { page, sanity, children, lang, locationPage } = props;
  const indexStatus = page?.indexStatus || locationPage?.indexStatus || 'index';
  const title = page?.title || locationPage?.title;
  const description = page?.description || locationPage?.description || sanity?.business?.description;
  const company = page?.gbp?.name || locationPage?.company || sanity?.business?.name;
  const canonical =
    page?.slug?.current === 'home'
      ? sanity?.business?.websiteUrl
      : page?.isSelfReferencing === true
        ? `${sanity?.business?.websiteUrl}${page?.slug?.current}/`
        : (page?.canonical ?? locationPage?.canonical);


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={`${title} | ${company}`}
    >
      <link rel="canonical" href={canonical} />

      <meta
        name="robots"
        content={
          indexStatus === 'index' ? 'index, follow' : 'noindex, nofollow'
        }
      />

      <meta name="description" content={description} />
      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={sanity?.logos?.header?.image?.asset?.gatsbyImageData}
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={title} />
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={sanity?.business?.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {children}
      <script
        type="text/javascript"
        src="https://api.leadconnectorhq.com/js/reviews_widget.js"
      ></script>
    </Helmet>
  );
};

Seo.defaultProps = {
  lang: `en`,
  description: ``,
  canonical: ``,
  image: ``,
  children: ``,
};

Seo.propTypes = {
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  canonical: PropTypes.string,
  image: PropTypes.string,
  children: PropTypes.node,
  sanity: PropTypes.shape({
    business: PropTypes.object.isRequired,
  }).isRequired,
};

export { Seo };
